/**
 * Floor_Service.ts
 * Floor & Tables live-update signal over SSE (cookie auth — EventSource needs
 * no header). Deliberately a bare "something changed, go refetch" ping, no
 * payload — the reserved-hold computation stays client-side (see Floor.tsx);
 * this just replaces the old 5s client poll's TRIGGER with a server push.
 */

import { Hosp_Floor_Stream_Url } from '../../api/endpoints';

/** Opens the floor SSE stream. Auth is cookie-based, so EventSource works without a manual header. */
export function openFloorStream(onInvalidate: () => void): EventSource {
  const es = new EventSource(Hosp_Floor_Stream_Url, { withCredentials: true });
  es.addEventListener('invalidate', onInvalidate);
  return es;
}
